import { render, staticRenderFns } from "./BusinessDetailTabs.vue?vue&type=template&id=bebfe88e&"
import script from "./BusinessDetailTabs.vue?vue&type=script&lang=js&"
export * from "./BusinessDetailTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports